import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomerDetailComponent } from './customerdetail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [CustomerDetailComponent],
  exports: [
    CustomerDetailComponent
  ],
  providers: [
  ]
})
export class CustomerDetailModule { }
